import { Page } from '@ih/app/shared/apis/interfaces';

export class FindAllPagesSuccessEffect {
  public static readonly type = '[Project/Wiki/List] FindAllPagesSuccessEffect';
  constructor(public readonly pages: Page[]) {}
}
